import React from "react"
import Flex from "@/components/templates/flex"

export default () => (
  <Flex padding={[1, 2]} height="100%">
    <Flex width="1px" background="selected" height="100%" />
  </Flex>
)
